/**
 * 跨组件通讯类似vue bus通讯
 * 使用方式 https://www.jianshu.com/p/fb915d9c99c4
 * */ 
import { EventEmitter } from 'events'
export default new EventEmitter()